import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Form } from "antd";
import { useIntl } from "react-intl";
import moment from "moment";

import RangePickerItem, {
  getDateFromRangePicker,
} from "../../app/generic/rangePickerItem";
import InputItem from "../../app/generic/inputItem";
import SelectItem from "../../app/generic/selectItem";
import TableFilter from "../../app/generic/tableFilter";
import { loadCountries } from "../../../modules/staticDataLoad";
import FilterSubmit from "../../app/generic/tableFilter/filterSubmit";

import "./index.css";

const dateTimeFrom = moment(moment.now()).add(-1, "months");

const formName = "address-list";

function AddressListFilter({
  form,
  showFilter,
  loadAddresses,
  onSetShowFilter,
}) {
  const intl = useIntl();
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 15 },
    colon: false,
  };
  const { getFieldDecorator } = form;

  const [filterState] = useState(
    useSelector((state) => state.filter[formName])
  );
  useEffect(
    () => filterState && onSetShowFilter(true),
    [filterState, onSetShowFilter]
  );

  useEffect(() => {
    loadAddresses && loadAddresses(filterState && filterState.data);
  }, [loadAddresses, filterState]);

  const handleFiltering = useCallback(
    (e, onSetFilterState) => {
      e.preventDefault();
      form.validateFields((err, values) => {
        if (!err) {
          const params = {
            ...values,
            insertionDateFrom: getDateFromRangePicker(values.insertionDate, 0),
            insertionDateTo: getDateFromRangePicker(values.insertionDate, 1),
            insertionDate: undefined,
            changeDateFrom: getDateFromRangePicker(values.changeDate, 0),
            changeDateTo: getDateFromRangePicker(values.changeDate, 1),
            changeDate: undefined,
          };
          loadAddresses(params);
          onSetFilterState(params);
        }
      });
    },
    [form, loadAddresses]
  );

  const [countries, setCountries] = useState();
  useEffect(() => {
    loadCountries(setCountries);
  }, [intl.locale]);

  return (
    <TableFilter showFilter={showFilter}>
      <Form {...formItemLayout}>
        <Row>
          <Col span={12}>
            <InputItem
              label={intl.formatMessage({
                id: "address.name",
                defaultMessage: "Název",
              })}
              fieldName="name"
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <InputItem
              label={intl.formatMessage({
                id: "address.city",
                defaultMessage: "Město",
              })}
              fieldName="city"
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <InputItem
              label={intl.formatMessage({
                id: "address.contactPerson",
                defaultMessage: "Kontaktní osoba",
              })}
              fieldName="contactPerson"
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <RangePickerItem
              showRanges
              fieldName="insertionDate"
              label={intl.formatMessage({
                id: "address.insertionDate",
                defaultMessage: "Vytvoření zákazníka",
              })}
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
          </Col>
          <Col span={12}>
            <Row className="address-filter-street-row">
              <Col span={13}>
                <InputItem
                  label={intl.formatMessage({
                    id: "address.street",
                    defaultMessage: "Ulice",
                  })}
                  labelCol={5}
                  wrapperCol={17}
                  fieldName="street"
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
              <Col span={11}>
                <InputItem
                  labelCol={10}
                  wrapperCol={11}
                  label={intl.formatMessage({
                    id: "address.streetNumber",
                    defaultMessage: "Číslo popisné",
                  })}
                  fieldName="streetNumber"
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
            </Row>
            <Row className="address-filter-country-row">
              <Col span={8}>
                <InputItem
                  label={intl.formatMessage({
                    id: "address.zipCode",
                    defaultMessage: "PSČ",
                  })}
                  labelCol={9}
                  wrapperCol={15}
                  fieldName="zipCode"
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
              <Col span={16}>
                <SelectItem
                  label={intl.formatMessage({
                    id: "address.country",
                    defaultMessage: "Stát",
                  })}
                  labelCol={6}
                  wrapperCol={16}
                  options={countries}
                  fieldName="countryId"
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <InputItem
                  label={intl.formatMessage({
                    id: "address.contactPhone",
                    defaultMessage: "Telefon",
                  })}
                  fieldName="contactPhone"
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
              <Col span={12}>
                <InputItem
                  email
                  label={intl.formatMessage({
                    id: "address.contactEmail",
                    defaultMessage: "Email",
                  })}
                  fieldName="contactEmail"
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <RangePickerItem
                  showRanges
                  labelCol={3}
                  fieldName="changeDate"
                  label={intl.formatMessage({
                    id: "address.changeDate",
                    defaultMessage: "Editace",
                  })}
                  initialDateFrom={dateTimeFrom}
                  formItemLayout={formItemLayout}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
            </Row>
            <FilterSubmit
              form={form}
              formName={formName}
              filterState={filterState}
              onFilterClick={handleFiltering}
            />
          </Col>
        </Row>
      </Form>
    </TableFilter>
  );
}

export default Form.create()(AddressListFilter);
